"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectAllBar = SelectAllBar;
exports.CheckBox = CheckBox;
const jsx_runtime_1 = require("react/jsx-runtime");
const lucide_react_1 = require("lucide-react");
const cn_1 = require("../lib/cn");
/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ 3 Nov 2026 · *Összes kijelölése / Kijelölés törlése* — every multi filter.  │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * The product owner's ruling with the multi-select filters: each one carries both, so twelve
 * statuses minus two is two clicks and a tick each rather than ten ticks. One block, shared by the
 * list toolbar's multi panel and `MultiSelect`, so the two read as one control.
 *
 * ⚠️ **4 Nov 2026 · a CHECKBOX ROW, not two links side by side** — the product owner: the pair
 * wrapped into two lines each in a narrow panel and read as neither a choice nor a heading.
 * *Kijelölés törlése* stays a link, alone on the row above; *Összes kijelölése* is the first row of
 * the list, with the same box as every option under it — ticked when all are chosen, a dash when
 * some are. Ticking it when all are chosen un-chooses what is SHOWN.
 *
 * ⚠️ **"Select all" takes what is SHOWN** — with a search typed, the matches; that is what the
 * person is looking at, and choosing what they cannot see would be a surprise. It ADDS to the
 * choice rather than replacing it, so a search for a second group extends the first.
 *
 * ⚠️ The link is disabled when it would change nothing, rather than hidden: a row that comes and
 * goes moves the options under the pointer.
 */
function SelectAllBar({ shown, chosen, onChange, selectAll, deselectAll, }) {
    const missing = shown.filter((value) => !chosen.includes(value));
    const state = shown.length > 0 && missing.length === 0
        ? 'on'
        : missing.length < shown.length
            ? 'mixed'
            : 'off';
    return ((0, jsx_runtime_1.jsxs)("div", { className: "border-b", children: [(0, jsx_runtime_1.jsx)("div", { className: "flex justify-end px-2 pt-1", children: (0, jsx_runtime_1.jsx)("button", { type: "button", disabled: chosen.length === 0, onClick: () => {
                        onChange([]);
                    }, className: "text-primary rounded-sm px-1 py-0.5 text-[12px] font-medium outline-none hover:underline focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-default disabled:text-muted-foreground disabled:no-underline", children: deselectAll }) }), (0, jsx_runtime_1.jsx)("div", { className: "p-1 pt-0", children: (0, jsx_runtime_1.jsxs)("button", { type: "button", role: "checkbox", "aria-checked": state === 'mixed' ? 'mixed' : state === 'on', disabled: shown.length === 0, onClick: () => {
                        onChange(state === 'on'
                            ? chosen.filter((value) => !shown.includes(value))
                            : [...chosen, ...missing]);
                    }, className: "hover:bg-accent flex w-full items-center gap-2 rounded-sm px-2 py-1.5 text-left text-[13px] outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50", children: [(0, jsx_runtime_1.jsx)(CheckBox, { state: state }), (0, jsx_runtime_1.jsx)("span", { className: "flex-1", children: selectAll })] }) })] }));
}
/** The square at a row's front — the kit `Checkbox`'s look, drawn, not an input. */
function CheckBox({ state }) {
    return ((0, jsx_runtime_1.jsxs)("span", { "aria-hidden": "true", className: (0, cn_1.cn)('grid size-4 shrink-0 place-items-center rounded-[4px] border', state === 'off' ? 'border-input' : 'bg-primary border-primary text-primary-foreground'), children: [state === 'on' ? (0, jsx_runtime_1.jsx)(lucide_react_1.Check, { size: 11, strokeWidth: 3 }) : null, state === 'mixed' ? (0, jsx_runtime_1.jsx)(lucide_react_1.Minus, { size: 11, strokeWidth: 3 }) : null] }));
}
//# sourceMappingURL=select-all-bar.js.map